import React, { useState, useRef, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import TokenEntry from "./TokenEntryScreen";
import TokenDisplay from "./TokenDisplayScreen";
import Header from "./Header";
import Footer from "./Footer";
import {
  createBrowserRouter,
  BrowserRouter as Router,
  Routes,
  Route,
  RouterProvider,
  Navigate,
} from "react-router-dom";

// Define routes
const routes = [
  {
    path: "/",
    element: <TokenDisplay />,
  },
  {
    path: "/entry",
    element: <TokenEntry />,
  },
  {
    path: "*",
    element: <Navigate to="/" />,
  },
];

// Create router with v7_startTransition enabled
const router = createBrowserRouter(routes, {
  future: {
    v7_startTransition: true, // Opt-in to the future behavior
  },
});


const App = () => {
  const [currentScreen, setCurrentScreen] = useState("TokenDisplay");
  const tokenDisplayRef = useRef(null);

  const handleEnableSpeech = () => {
    if (tokenDisplayRef.current) {
      tokenDisplayRef.current.enableSpeech();
    }
  };

  return (
    <>
      <Header
        currentScreen={currentScreen}
        setCurrentScreen={setCurrentScreen}
        enableSpeech={handleEnableSpeech}
      />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {/* TokenDisplay route */}
          <Route
            path="/"
            element={<TokenDisplay ref={tokenDisplayRef} />}
          />
          {/* TokenEntry route */}
          <Route
            path="/entry"
            element={<TokenEntry />}
          />
          {/* Redirect unmatched routes to `/` */}
          {/* <Route path="*" element={<Navigate to="/" />} /> */}
        </Routes>
      </Suspense>
      <Footer />
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);

reportWebVitals();
